import React from 'react';
import styled from 'styled-components';
import { RoundedButton } from '../RoundedButton/RoundedButton';
import { Link } from 'react-router-dom';
import { headerStyles } from '../../pages/headerStyles';
import { useUser } from '../../utils/user';
import { useLogout } from '../../hooks/useLogout';

export const StyledLink = styled(Link)`
    margin-right: 20px;
    font-weight: bold;
    color: #34404e;
    text-decoration: none;
`;

const StyledA = styled.a`
    margin-right: 20px;
    font-weight: bold;
    color: #34404e;
    text-decoration: none;
`;

export const Navigation = (): JSX.Element => {
    const [logout] = useLogout();
    const user = useUser();
    const isLoggedIn = Boolean(user !== null);
    const headerClasses = headerStyles();

    return (
        <nav>
            <StyledLink to={'/apps'}>Apps</StyledLink>
            <StyledLink to={'/developer'}>Developers</StyledLink>
            <StyledA href="https://bokun.dev" target="_blank">
                Docs
            </StyledA>
            {isLoggedIn && (
                <StyledLink
                    to={'#'}
                    onClick={() => {
                        logout();
                    }}
                >
                    Logout
                </StyledLink>
            )}
            {!isLoggedIn && <StyledLink to={'/developer/signup'}>Signup</StyledLink>}

            {isLoggedIn ? (
                <Link to={'/extranet'}>
                    <RoundedButton
                        variant="contained"
                        color="primary"
                        className={headerClasses.link}
                    >
                        My account
                    </RoundedButton>
                </Link>
            ) : (
                <Link to={'/developer/login'}>
                    <RoundedButton
                        variant="contained"
                        color="primary"
                        className={headerClasses.link}
                    >
                        Login
                    </RoundedButton>
                </Link>
            )}
        </nav>
    );
};
